import { useEffect, useState } from "react";
import {
  CART_KEY,
  getCart,
  addToCart,
  removeFromCart,
  updateCartQty,
  clearCart,
  saveCart,
} from "../../../utils/cart";

export const useCart = () => {
  const [cart, setCart] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setCart(getCart());
    setReady(true);
  }, []);

  /* El carrito se comparte entre las pestañas abiertas.
   *
   * Antes cada pestaña leia el localStorage una sola vez, al montar, y
   * despues vivia de su copia en memoria. Si el cliente agregaba algo
   * desde el catalogo en otra pestaña, la del carrito seguia mostrando lo
   * de antes, y la del checkout reservaba lo que tenia guardado y no lo
   * que el cliente acababa de elegir.
   *
   * El evento `storage` solo le llega a las OTRAS pestañas, nunca a la que
   * hizo el cambio, asi que no hay riesgo de que una pestaña se pise a si
   * misma mientras el cliente esta escribiendo.
   */
  useEffect(() => {
    const alCambiar = (e) => {
      /* Llega por cualquier clave que se guarde. Y con `key` en null
         cuando alguien hizo localStorage.clear(), que tambien vacia el
         carrito. */
      if (e.key !== null && e.key !== CART_KEY) return;

      setCart(getCart());
    };

    window.addEventListener("storage", alCambiar);
    return () => window.removeEventListener("storage", alCambiar);
  }, []);

  const add = (product, qty = 1) => {
    const updated = addToCart(product, qty);
    setCart(updated);
  };

  const remove = (producto_id) => {
    const updated = removeFromCart(producto_id);
    setCart(updated);
  };

  const updateQty = (producto_id, cantidad) => {
    const updated = updateCartQty(producto_id, cantidad);
    setCart(updated);
  };

  const clear = () => {
    clearCart();
    setCart([]);
  };

  const totalItems = cart.reduce((sum, p) => sum + p.cantidad, 0);
  const subtotal = cart.reduce((sum, p) => sum + p.precio_unitario * p.cantidad, 0);
  const coreChargeTotal = cart.reduce(
    (sum, p) => sum + Number(p.core_charge || 0) * p.cantidad,
    0
  );
  const grandTotal = subtotal + coreChargeTotal;
  const replaceCart = (newCart) => {
    const normalized = newCart.map((item) => ({
      producto_id: item.producto_id,
      nombre: item.nombre ?? "",
      precio_unitario: Number(item.precio_unitario),
      core_charge: Number(item.core_charge || 0),
      imagen: item.imagen,
      cantidad: item.cantidad,
      stock: item.stock,
    }));

    setCart(normalized);
    saveCart(normalized);
  };

  return {
    cart,
    ready,
    add,
    remove,
    updateQty,
    clear,
    totalItems,
    subtotal,
    coreChargeTotal,
    grandTotal,

    replaceCart,
  };
};
